import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import { Grid } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import { DEFAULT_MOBILE_PROPS, DEFAULT_PAGINATION_PROPS, DEFAULT_TABLET_PROPS } from './PaginatedGrid.constants';
import { getGridProps, getPaginationProps, getPageSize } from './PaginatedGrid.utils';
import { toArray } from '../../../../services/components';
import { classNames } from '../../../../utils/classname';
import { ChildrenPropType } from '../../types/component';
import Pagination from '../Pagination';
import { DirectionIndicatorIconsPropType } from '../Pagination/components/PaginationIndicators/PaginationIndicators.types';
import './PaginatedGrid.css';
var defaultProps = {
  items: [],
  children: [],
  columns: 3,
  rows: 1,
  mobile: DEFAULT_MOBILE_PROPS,
  tablet: DEFAULT_TABLET_PROPS,
  pagination: DEFAULT_PAGINATION_PROPS,
  className: '',
  tight: false
};
export default function PaginatedGrid(_ref) {
  var _classNames;
  var items = _ref.items,
    children = _ref.children,
    columns = _ref.columns,
    rows = _ref.rows,
    mobile = _ref.mobile,
    tablet = _ref.tablet,
    pagination = _ref.pagination,
    className = _ref.className,
    tight = _ref.tight;
  var allItems = [].concat(_toConsumableArray(toArray(items)), _toConsumableArray(toArray(children)));
  if (_isEmpty(allItems)) {
    return null;
  }
  var gridProps = getGridProps({
    columns: columns
  }, mobile, tablet);
  var pageSize = getPageSize(allItems, {
    columns: columns,
    rows: rows
  }, mobile, tablet);
  var _getPaginationProps = getPaginationProps(pagination),
    displayPagination = _getPaginationProps.display,
    defaultActivePage = _getPaginationProps.defaultActivePage,
    onlyPageIndicators = _getPaginationProps.onlyPageIndicators,
    directionIndicatorIcons = _getPaginationProps.directionIndicatorIcons;
  var displayIndicators = allItems.length > pageSize && displayPagination;
  var componentClass = classNames((_classNames = {
    'paginated-grid': true
  }, _defineProperty(_classNames, className, !!className), _defineProperty(_classNames, "tight", tight), _classNames));
  return /*#__PURE__*/React.createElement("div", {
    className: componentClass
  }, /*#__PURE__*/React.createElement(Pagination, {
    pageSize: pageSize,
    items: allItems,
    defaultActivePage: defaultActivePage
  }, /*#__PURE__*/React.createElement(Grid, gridProps, /*#__PURE__*/React.createElement(Pagination.Elements, null, function (activeItems) {
    return activeItems.map(function (item) {
      return /*#__PURE__*/React.createElement(Grid.Column, {
        key: item.key
      }, item);
    });
  })), displayIndicators && /*#__PURE__*/React.createElement(Pagination.Indicators, {
    onlyPageIndicators: onlyPageIndicators,
    directionIndicatorIcons: directionIndicatorIcons,
    disableIndicatorsOnLimit: true
  })));
}
PaginatedGrid.defaultProps = defaultProps;